import {
    REQUEST_ARRIVALS_PROBLEM,
    REQUEST_ARRIVALS_PROBLEM_FAILURE,
    REQUEST_ARRIVALS_PROBLEM_SUCCESS
} from "../../../constant/transaction/ShipmentConstant";

const initialState = {
    arrivalsProblem: {
        data: [],
        status: 'idle',
        isLoading: true,
    },
};


export const arrivalsProblemReducer = (state = initialState, action) => {
    const {type, payload} = action;
    switch (type) {
        case REQUEST_ARRIVALS_PROBLEM:
            return {
                ...state,
                arrivalsProblem: {
                    data: [],
                    status: 'fetching',
                    isLoading: true,
                },
            };
        case REQUEST_ARRIVALS_PROBLEM_SUCCESS:
            return {
                ...state,
                arrivalsProblem: {
                    data: payload,
                    status: 'ready',
                    isLoading: false,
                },
            };
        case REQUEST_ARRIVALS_PROBLEM_FAILURE:
            return {
                ...state,
                arrivalsProblem: {
                    data: [],
                    status: 'fetching',
                },
            };
        default:
            return state;
    }
}
